<template>

    <v-container>


        <v-layout row wrap>

            <v-flex xs12 sm12 pb-5 mb-2>
            </v-flex>

        </v-layout>

        <v-layout row wrap>

            <v-flex xs12 sm12>
                <v-layout row>
                    <v-flex xs12>
                        <v-card>
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12 md8>
                                        <v-card-title class="headline">
                                            Follow Up
                                        </v-card-title>
                                    </v-flex>
                                    <v-flex xs12 md1>
                                        <v-checkbox
                                                v-model="showAll" color="secondary"
                                                label="Show all"></v-checkbox>
                                        </v-flex>
                                    <v-flex xs12 md3>
                                        <v-text-field
                                                v-model="search"
                                                append-icon="search"
                                                label="Search"
                                                single-line
                                                hide-details
                                                clearable
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>

                            <!--                            Status Or Filter Header-->
                            <v-layout row wrap>

                                <v-flex xs12 md2 pl-4 pr-2>
                                    <v-autocomplete
                                            clearable
                                            :items="getCustomers"
                                            label="Customer"
                                            v-model="selectedCustomersID"
                                            item-value="id"
                                            item-text="name"
                                            :search-input.sync="searchCustomer"
                                            height="48"
                                    ></v-autocomplete>
                                </v-flex>


                                <v-flex xs12 md2 pl-4 pr-2>
                                    <v-autocomplete
                                            clearable
                                            :items="getAllSuppliers"
                                            label="Supplier"
                                            v-model="selectedSupplierID"
                                            item-value="id"
                                            item-text="name"
                                            height="48"
                                    ></v-autocomplete>
                                </v-flex>


                                <v-flex xs12 md2 pl-4 pr-2>
                                    <v-badge
                                            v-model="selectedSupplierOrderPositionStatusIDs.length > 0" left>
                                        <template v-slot:badge>
                                            <span v-if="selectedSupplierOrderPositionStatusIDs.length > 0">{{ selectedSupplierOrderPositionStatusIDs.length }}</span>
                                        </template>

                                        <v-autocomplete style="max-width: 250px"
                                                clearable
                                                :items="supplierOrderPositionStatuses"
                                                label="Supplier Position Status"
                                                v-model="selectedSupplierOrderPositionStatusIDs"
                                                item-value="id"
                                                item-text="name"
                                                multiple
                                                chips
                                                deletable-chips
                                                small-chips
                                                height="48"
                                        ></v-autocomplete>
                                    </v-badge>



                                </v-flex>


                                <v-flex grow>

                                </v-flex>

                                <v-flex xs12 md2 pl-4 pr-2>
                                        <v-autocomplete
                                                label="Filter Dates"
                                                multiple
                                                :deletable-chips=chipsDeletable
                                                v-model="selectedDateFilters"
                                                item-text="displayName"
                                                :items="dateFilters"
                                                return-object
                                                clearable
                                                height="48"
                                        >

                                        </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 md2 pl-4 pr-2>
                                    <v-menu
                                            ref="menu"
                                            v-model="selectFromMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    :value="selectFromDate | toDateOnly"
                                                    label="Select From"
                                                    prepend-icon="fas fa-calendar"
                                                    readonly
                                                    v-on="on"
                                                    height="48"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="selectFromDate" @input="selectFromMenu = false" no-title
                                                       scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn flat color="primary"
                                                   @click="resetDate(selectFromDate, selectFromMenu)">CLEAR
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>

                                <v-flex xs12 md2 pl-4 pr-2>
                                    <v-menu
                                            ref="menu"
                                            v-model="selectToMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    :value="selectToDate | toDateOnly"
                                                    label="Select To"
                                                    prepend-icon="fas fa-calendar"
                                                    readonly
                                                    v-on="on"
                                                    height="48"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="selectToDate" @input="selectToMenu = false" no-title
                                                       scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn flat color="primary" @click="resetDate(selectToDate, selectToMenu)">
                                                CLEAR
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>


                            </v-layout>

                            <v-data-table
                                    :headers="headers"
                                    :items="getItems"
                                    :pagination.sync="pagination"
                                    :total-items=total
                                    class="elevation-0"
                                    :loading="loading"
                                    :rows-per-page-items="rowsPageItems"
                            >

                                <template slot="headerCell" slot-scope="props">
                                    <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                        <span>
                                          {{ props.header.text }}
                                        </span>
                                    </v-tooltip>
                                </template>
                                <template slot="items" slot-scope="props">
                         <!--           <v-touch tag="tr"
                                             @doubletap="openDialog(props.item.id)"
                                             @dblclick="openDialog(props.item.id)">-->

                                        <tr>

                                        <td>{{ props.item.purchase_order.customer.name }}</td>

                                        <td class="text-xs-left">
                                            <v-btn   :loading="loadingPurchaseOrder === props.item.id + 'PONumber'"
                                                     small
                                                     flat
                                                     @click.native="openPurchaseOrderDialog(props.item.purchase_order.id, props.item.id + 'PONumber' )"
                                            >
                                                {{ props.item.purchase_order.customer_purchase_order_number}}
                                            </v-btn>
                                        </td>

                                        <td class="text-xs-left">{{ props.item.internal_number }}</td>

                                        <td class="text-xs-left">
                                            <v-btn  :loading="loadingPurchaseOrder === props.item.id  + 'OCNumber' "
                                                    small
                                                    flat
                                                     @click.native="openPurchaseOrderDialog(props.item.purchase_order.id, props.item.id + 'OCNumber')"
                                            >
                                                {{ props.item.purchase_order.purchase_orders_number}}
                                            </v-btn>
                                        </td>

                                        <td class="text-xs-left">
                                            <div :class="deadlineClientDelivery(props.item.delivery_date)">{{
                                                props.item.delivery_date | toDateOnly }}
                                            </div>
                                        </td>

                                        <td class="text-xs-left">{{props.item.product.manufacturer.name}}</td>

                                        <td class="text-xs-left">{{ props.item.product.reference }}</td>

                                        <td v-show="getPropertyByPath(props.item,'procurement_position.purchase_orders_position.purchase_orders_positions_status.name','start-procurement') !== 'start-procurement'" class="text-xs-left">
                                            {{
                                            getPropertyByPath(props.item,'procurement_position.purchase_orders_position.purchase_orders_positions_status.name','Start Procurement')}}
                                        </td>

                                        <td v-show="getPropertyByPath(props.item,'procurement_position.purchase_orders_position.purchase_orders_positions_status.name','start-procurement') === 'start-procurement'" class="text-xs-left">
                                            <v-btn  :loading="loadingPurchaseOrder === props.item.id + 'Procurement'"
                                                    small
                                                    flat
                                                    @click.native="openPurchaseOrderDialog(props.item.purchase_order.id, props.item.id + 'Procurement')"
                                            >
                                              Start Procurement
                                            </v-btn>
                                        </td>

                                        <td class="text-xs-left">
                                            {{
                                            getPropertyByPath(props.item,'procurement_position.suppliers_orders_position.suppliers_order.supplier.name','No Supplier Order')}}
                                        </td>

                                        <td class="text-xs-left">{{
                                            getPropertyByPath(props.item,'procurement_position.suppliers_orders_position.suppliers_order.suppliers_orders_confirmation_number','-')
                                            }}
                                        </td>
                                        <td class="text-xs-left">
                                            <v-btn  :loading="loadingSupplierOrder === getPropertyByPath(props.item,'procurement_position.suppliers_orders_position.id','-')" :disabled="getPropertyByPath(props.item,'procurement_position.suppliers_orders_position.suppliers_order.purchase_orders_number','-') === '-'"
                                                    small
                                                     flat
                                                    @click.native="openSupplierOrderDialog(getPropertyByPath(props.item,'procurement_position.suppliers_orders_position.suppliers_order.id','-'), getPropertyByPath(props.item,'procurement_position.suppliers_orders_position.id','-'))"
                                            >
                                                {{  getPropertyByPath(props.item,'procurement_position.suppliers_orders_position.suppliers_order.purchase_orders_number','-')}}
                                            </v-btn>
                                        </td>
                                        <td class="text-xs-left">
                                            <div :class="deadlineArrivalDate(getPropertyByPath(props.item,'procurement_position.suppliers_orders_position.est_receiving_date','-'),
                                             getPropertyByPath(props.item,'procurement_position.suppliers_orders_position.suppliers_orders_positions_status_id','-') )
">
                                                {{
                                                getPropertyByPath(props.item,'procurement_position.suppliers_orders_position.est_receiving_date','-')
                                                | toDateOnly
                                                }}
                                            </div>

                                        </td>
                                        <td class="text-xs-left">{{
                                            getPropertyByPath(props.item,'procurement_position.suppliers_orders_position.suppliers_orders_positions_status.name','-')
                                            }}
                                        </td>

                                        <td class="text-xs-left" v-show="getPropertyByPath(props.item,'procurement_position.purchase_orders_position.invoice_position.invoice.invoice_number','-') !== '-'">

                                            <v-btn  :loading="loadingInvoice === props.item.id + 'Invoice'"
                                                    small
                                                    flat
                                                    @click.native="openInvoiceDialog(props.item.procurement_position.purchase_orders_position.invoice_position.invoice.id, props.item.id + 'Invoice')"
                                            >
                                                {{
                                                getPropertyByPath(props.item,'procurement_position.purchase_orders_position.invoice_position.invoice.invoice_number','-')}}
                                            </v-btn>
                                        </td>

                                        <td class="text-xs-left" v-show="getPropertyByPath(props.item,'procurement_position.purchase_orders_position.invoice_position.invoice.invoice_number','-') === '-'">
                                            -
                                        </td>


                                        </tr>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>

                </v-layout>

                <!--<addSupplierOrderDialog v-on:closing="closedSupplierOrderDialog" v-on:mounting="showSupplierOrderDialog" v-if="renderSupplierOrderDialog"></addSupplierOrderDialog>-->

                <addSupplierOrderDialog v-if="supplierOrderDialogState"></addSupplierOrderDialog>

                <addPurchaseOrderDialog v-if="purchaseOrderDialogState"></addPurchaseOrderDialog>

                <addProcurementDialog v-if="procurementDialogState"></addProcurementDialog>

                <addInvoiceDialog v-if="invoiceDialogState"></addInvoiceDialog>

            </v-flex>
        </v-layout>

    </v-container>

</template>

<script>
    import {
        Settings,
        FollowUp,
        Customer,
        SupplierOrder,
        SupplierOrderPosition,
        PurchaseOrder,
        Procurement,
        Invoice
    } from '../../store/namespace-helper'
    import addSupplierOrderDialog from '../SupplierOrders/AddSupplierOrderDialog.vue'
    import addPurchaseOrderDialog from '../PurchaseOrders/AddPurchaseOrderDialog.vue'
    import addProcurementDialog from '../Procurements/AddProcurementDialog.vue'
    import addInvoiceDialog from '../Invoices/AddInvoiceDialog.vue'
    import _ from 'lodash'
    import moment from 'moment'

    import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'
    import {propertyHelperMixin} from '../../mixins/propertyHelperMixin'

    export default {
      name: 'FollowUp',
      components: {
        addSupplierOrderDialog,
        addPurchaseOrderDialog,
        addProcurementDialog,
        addInvoiceDialog
      },
      mixins: [dateFunctionFilters, propertyHelperMixin],
      props: {},
      data () {
        return {
          isVisible: false,
          pagination: {'sortBy': 'delivery_date', 'ascending': true},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [25, 10, 50, 100, 250],
          deleteDialog: false,
          deleteChecked: false,
          deleteFormValidation: false,
          supplierOrderToDelete: null,
          selectedSupplierID: null,
          selectedSupplierOrderPositionStatusIDs: [],
          selectedCustomersID: null,
          selectFromDate: null,
          selectToDate: null,
          selectToMenu: false,
          selectFromMenu: false,
          chipsDeletable: true,
          selectedDateFilters: [],
          dateFilters: [
            {
              column: 'delivery_date',
              displayName: 'Delivery Client',
              relation: ''
            },
            {
              column: 'est_receiving_date',
              displayName: 'Arrival Date',
              relation: 'procurementPosition.suppliersOrdersPosition'
            }
          ],
          loadingSupplierOrder: 0,
          loadingPurchaseOrder: 0,
          loadingProcurement: 0,
          loadingInvoice: 0,
          renderSupplierOrderDialog: false,
          renderOrderDialog: false,
          renderProcurementDialog: false,
          supplierOrderPositionStatuses: [],
          searchCustomer: null,
          showAll: false
        }
      },
      mounted () {
        this.loadItems()
        this.loadAllSuppliers()
        this.loadStatuses()
        this.loadCustomers()
        // applying styles to selector filters
        let selectors = document.getElementsByClassName('v-select__selections')
        for (let i = 0; i < selectors.length; i++) {
          selectors[i].style.maxHeight = '42px'
          selectors[i].style.overflowX = 'scroll'
        }
      },
      methods: {
        loadItems () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination

          const query = {
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : '',
            customers_id: this.selectedCustomersID ? this.selectedCustomersID : 0,
            suppliers_id: this.selectedSupplierID ? this.selectedSupplierID : 0,
            selectedFrom: this.selectFromDate ? this.selectFromDate : null,
            selectedTo: this.selectToDate ? this.selectToDate : null,
            filterDates: this.selectedDateFilters,
            selectedSupplierOrderPositionStatuses: this.selectedSupplierOrderPositionStatusIDs,
            showAll: this.showAll
          }
          this.$store.dispatch(FollowUp.actions.loadFollowUps, query)
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450),
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
          setTimeout(function () {
            location.reload()
          }, 850)
        },
        loadAllSuppliers: function () {
          this.$store.dispatch(Settings.actions.loadAllSuppliers)
        },
        loadCustomers () {
          const query = {
            search: this.searchCustomer ? this.searchCustomer : ''
          }
          this.$store.dispatch(Customer.actions.loadCustomers, query)
        },
        resetDate (model, menu) {
          if (this.selectFromDate === model) {
            this.selectFromDate = null
            this.selectFromMenu = false
          } else if (this.selectToDate === model) {
            this.selectToDate = null
            this.selectToMenu = false
          }
        },
        deadlineClientDelivery (deadline) {
          var duration = moment.duration(moment(deadline, 'YYYY-MM-DD hh:mm:ss').diff(moment()))
          var hours = duration.asHours()
          if (hours <= 48) {
            return 'deadlineFieldRed'
          } else if (hours <= 96) {
            return 'deadlineFieldYellow'
          } else {
            return 'deadlineFieldNormal'
          }
        },
        deadlineArrivalDate (deadline, statusId) {
          var duration = moment.duration(moment(deadline, 'YYYY-MM-DD hh:mm:ss').diff(moment()))
          var hours = duration.asHours()
          if (statusId !== '-') {
            if (statusId === 6) {
              return 'deadlineFieldGreen'
            }
          }
          if (hours <= 48) {
            return 'deadlineFieldRed'
          } else if (hours <= 96) {
            return 'deadlineFieldYellow'
          } else {
            return 'deadlineFieldNormal'
          }
        },
        openSupplierOrderDialog (val, positionsId) {
          if (val !== null) {
            this.loadingSupplierOrder = positionsId
            this.$store.dispatch(SupplierOrder.actions.loadSupplierOrderById, val).then(response => {
              this.$store.dispatch(SupplierOrder.actions.setSelectedSupplierOrder, response.data.data)
       /*       this.renderSupplierOrderDialog = true */
              this.$store.dispatch(SupplierOrder.actions.openCloseDialog)
              this.loadingSupplierOrder = 0
            }).catch(err => {
              console.log(JSON.stringify(err))
              this.loadingSupplierOrder = 0
            })
          }
        },
        openInvoiceDialog (val, positionsId) {
          if (val !== null) {
            this.loadingInvoice = positionsId
            this.$store.dispatch(Invoice.actions.loadInvoiceById, val).then(response => {
              this.$store.dispatch(Invoice.actions.setSelectedInvoice, response.data.data)
                      /*       this.renderSupplierOrderDialog = true */
              this.$store.dispatch(Invoice.actions.openCloseDialog)
              this.loadingInvoice = 0
            }).catch(err => {
              console.log(JSON.stringify(err))
              this.loadingInvoice = 0
            })
          }
        },
        showSupplierOrderDialog (event) {
          console.log('showSupplierOrderDialog event: ' + event)
          if (!event) {
            this.$store.dispatch(SupplierOrder.actions.openCloseDialog)
          }
        },
        closedSupplierOrderDialog (event) {
          console.log('closedSupplierOrderDialog event: ' + event)
          if (!event) {
            setTimeout(() => {
              this.renderSupplierOrderDialog = false
            }, 350)
          }
        },
        openPurchaseOrderDialog (val, positionsId) {
          if (val !== null) {
            this.loadingPurchaseOrder = positionsId
            this.$store.dispatch(PurchaseOrder.actions.loadPurchaseOrderById, val).then(response => {
              this.$store.dispatch(PurchaseOrder.actions.setSelectedPurchaseOrder, response.data.data)
              this.$store.dispatch(PurchaseOrder.actions.openCloseDialog)
              this.loadingPurchaseOrder = 0
            }).catch(err => {
              console.log(JSON.stringify(err))
              this.loadingPurchaseOrder = 0
            })
          }
        },
        openProcurementDialog (val, positionsId) {
          if (val !== null) {
/*            this.loadingProcurement = positionsId
            this.$store.dispatch(Procurement.actions.openCloseDialog)
            this.loadingProcurement = 0 */
          }
        },
        loadStatuses () {
          this.$store.dispatch(SupplierOrderPosition.actions.loadStatuses).then(response => {
            this.supplierOrderPositionStatuses = response.data.data
          })
        }
      },
      computed: {
        getItems () {
          this.total = this.$store.getters[FollowUp.getters.followUps].total
          return this.$store.getters[FollowUp.getters.followUps].data
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        getActiveTab () {
          if (this.procurementId === null) {
            return 0
          } else {
            return 2
          }
        },
        supplierOrderDialogState () {
          return this.$store.getters[SupplierOrder.getters.getOpenDialogState]
        },
        purchaseOrderDialogState () {
          return this.$store.getters[PurchaseOrder.getters.getOpenDialogState]
        },
        procurementDialogState () {
          return this.$store.getters[Procurement.getters.getOpenDialogState]
        },
        invoiceDialogState () {
          return this.$store.getters[Invoice.getters.getOpenDialogState]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        getAllSuppliers () {
          return this.$store.getters[Settings.getters.getAllSuppliers]
        },
        getCustomers () {
          return this.$store.getters[Customer.getters.customers]
        },
        headers () {
          return [
                    {text: 'Customer(Client)', value: 'purchase_order.customer.name', sortable: false},
            {
              text: 'Purchase Order',
              value: 'purchase_order.customer_purchase_order_number',
              sortable: false
            },
                    {text: 'Internal Number', value: 'internal_number', sortable: false},
                    {text: 'OC Number', value: 'purchase_order.purchase_orders_number', sortable: false},
                    {text: 'Delivery Client', value: 'delivery_date'},
                    {text: 'Brand', value: 'product.manufacturer.name', sortable: false},
                    {text: 'Partnumber', value: 'product.reference', sortable: false},
              {text: 'Order Position Status (Client)', value: 'product.reference', sortable: false},
            {
              text: 'Supplier',
              value: 'procurement_position.suppliers_orders_position.suppliers_order.supplier.name',
              sortable: false
            },
            {
              text: 'Supplier AB Number',
              value: 'procurement_position.suppliers_orders_position.suppliers_order.suppliers_orders_confirmation_number',
              sortable: false
            },
            {
              text: 'Our PO',
              value: 'procurements_position.suppliers_orders_position.suppliers_order.purchase_orders_number',
              sortable: false
            },
            {
              text: 'Arrival Date',
              value: 'procurements_positions:id:purchase_orders_positions_id|suppliers_orders_positions:id:procurements_positions_id|suppliers_orders_positions.est_receiving_date',
              sortable: true
            },
            {
              text: 'Supplier Order Position Status',
              value: 'suppliers_orders_positions.suppliersOrdersPositionsStatus.name',
              sortable: false
            },
            {
              text: 'Invoice Number',
              value: 'procurement_position.purchase_orders_position.invoice_position.invoice.invoice_number',
              sortable: false
            }
          ]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        showAll: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectedSupplierID: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectedCustomersID: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectFromDate: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectToDate: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectedDateFilters: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectedSupplierOrderPositionStatusIDs: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        searchCustomer: {
          handler (val) {
            this.loadCustomers()
          },
          deep: true
        }

/*        supplierOrderDialogState: {
          handler (val) {
            if (!val) {
              this.renderSupplierOrderDialog = false
            }
          },
          deep: true
        } */
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

    .deadlineFieldGreen {
        white-space: nowrap;
        text-align: left;
        height: 44px;
        color: rgba(19, 113, 19, 0.75);
        font-weight: bold;
        padding-bottom: 15px;
        padding-top: 15px;
    }

    .deadlineFieldYellow {
        white-space: nowrap;
        text-align: left;
        height: 44px;
        color: rgba(255, 194, 16, 0.83);
        font-weight: bold;
        padding-bottom: 15px;
        padding-top: 15px;
    }

    .deadlineFieldRed {
        white-space: nowrap;
        /*        background-color: rgba(255, 0, 0, 0.75);*/
        text-align: left;
        height: 44px;
        /* color: white;*/
        color: rgba(255, 0, 0, 0.75);
        font-weight: bold;
        /*        border-radius: 16px;*/
        padding-bottom: 15px;
        padding-top: 15px;
    }

    .deadlineFieldNormal {
        white-space: nowrap;
        text-align: left;
        height: 44px;
        color: rgba(0, 0, 0, 0.75);
        font-weight: bold;
        padding-bottom: 15px;
        padding-top: 15px;
    }


</style>




// WEBPACK FOOTER //
// src/components/FollowUp/FollowUp.vue